import { render, staticRenderFns } from "./editProfile.vue?vue&type=template&id=c4e04b06&scoped=true"
import script from "./editProfile.vue?vue&type=script&lang=js"
export * from "./editProfile.vue?vue&type=script&lang=js"
import style0 from "./editProfile.vue?vue&type=style&index=0&id=c4e04b06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e04b06",
  null
  
)

export default component.exports